import { Transaction } from 'api/types/transaction/transactionApiTypes'

import { getBaseFiatValue } from './getBaseTxnFiatAmounts'

export type TxnValueOverride = {
  asset: string
  created_at: string
  id: string
  org: string
  status: 'ACTIVE' | 'INACTIVE'
  transaction_id: string
  updated_at: string
  value: number
}

export default function getBaseTxnAndFiatValues(txn: Transaction) {
  const {
    tokenId,
    value: {
      value: { amount: txnValue, asset, contractAddress },
    },
  } = txn
  const txnFiatValue = getBaseFiatValue(txn)

  return {
    value: txnValue,
    fiatValue: txnFiatValue,
    asset: {
      asset,
      contractAddress,
    },
    tokenId,
  }
}

export function getTxnOverrideValue(
  txn: Transaction | undefined,
  txnValueOverrides: Record<string, TxnValueOverride> | undefined
): number {
  if (txn && txnValueOverrides && txn.id in txnValueOverrides) {
    // TODO: When the overrides are localized to the currency, then we should
    //  check that the override is the right asset
    return txnValueOverrides[txn.id].value
  } else {
    return getBaseFiatValue(txn)
  }
}
